function SortButton({ sortOption, onClick, options, className }) {
    return (
        <button className={className} onClick={onClick}>
            {options[sortOption]}
        </button>
    );
}

export default SortButton;
